// src/components/workspace/context-menu/MenuIcon.tsx
import {
  AppWindow,
  ArrowLeft,
  Bug,
  Check,
  ChevronRight,
  Copy,
  Edit,
  Ellipsis,
  File,
  Folder,
  FolderMinus,
  FolderOpen,
  Image,
  Layers,
  Maximize,
  Minus,
  Monitor,
  Moon,
  Move,
  Palette,
  PanelRight,
  Plus,
  Settings,
  Share2,
  Shirt,
  Square,
  Sun,
  Trash,
  Trash2,
  Undo2,
  User,
  Wrench,
  ZoomIn
} from "lucide-react";
import { jsx } from "react/jsx-runtime";
var iconMap = {
  "app-window": AppWindow,
  "arrow-left": ArrowLeft,
  "bug": Bug,
  "check": Check,
  "chevron-right": ChevronRight,
  "copy": Copy,
  "edit": Edit,
  "ellipsis": Ellipsis,
  "file": File,
  "folder": Folder,
  "folder-minus": FolderMinus,
  "folder-open": FolderOpen,
  "image": Image,
  "layers": Layers,
  "maximize": Maximize,
  "minus": Minus,
  "monitor": Monitor,
  "moon": Moon,
  "move": Move,
  "palette": Palette,
  "panel-right": PanelRight,
  "plus": Plus,
  "settings": Settings,
  "share-2": Share2,
  "shirt": Shirt,
  "square": Square,
  "sun": Sun,
  "trash": Trash,
  "trash-2": Trash2,
  "undo-2": Undo2,
  "user": User,
  "wrench": Wrench,
  "zoom-in": ZoomIn
};
var MenuIcon = ({ name, className }) => {
  const IconComponent = iconMap[name];
  if (!IconComponent) return null;
  return /* @__PURE__ */ jsx(IconComponent, { className });
};

export {
  MenuIcon
};
//# sourceMappingURL=chunk-3AGD6MKM.js.map